import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import LoadingMorph from 'components/LoadingMorph/LoadingMorph';
import Typography from '@mui/material/Typography';
import { OpenInBrowser, Settings } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { BLOG_DEPLOYMENT_STATE } from '../../../helpers/graphql/hosting';
import Confetti from 'react-confetti';
import useWindowSize from 'react-use/lib/useWindowSize';
import Link from 'next/link';
import graphQLClient from 'helpers/graphQLClient';

export default function BlogCreationProgress({ blogId, editKey }) {
  const [complete, setComplete] = useState(false);
  const [error, setError] = useState(false);

  function checkBuildStatus() {
    if (complete || error) return;
    graphQLClient(BLOG_DEPLOYMENT_STATE, { id: blogId })
      .then(data => {
        if (data) {
          const { blogDeploymentState } = data;
          if (blogDeploymentState === 'READY') setComplete(true);
          else if (blogDeploymentState === 'ERROR') setError(true);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  useEffect(() => {
    setInterval(checkBuildStatus, 3000);
  }, []);

  const { width, height } = useWindowSize();

  const handleRefresh = () => {
    // Add a parameter to the current URL
    const currentUrl = window.location.href;
    const separator = currentUrl.includes('?') ? '&' : '?';
    const newUrl = `${currentUrl}${separator}blogId=${blogId}`;

    // Reload the current page with the new URL after a short delay
    setTimeout(() => {
      window.location.href = newUrl;
    }, 100);
  };

  if (complete)
    return (
      <div className="mt-3">
        <Typography variant="h4" className="tw-font-bold" gutterBottom>
          Your blog is ready!
        </Typography>
        <div className="mb-2">
          Personalize it even further with our intuitive site builder. Just hit
          the button below.
        </div>
        <Confetti width={width} height={height} recycle={false} />
        <div className="row">
          <div className="col-6 p-1">
            <a
              href={`https://${blogId}.truvvl.blog/api/preview`}
              target="_blank"
              rel="nofollow noreferrer noopener"
              onClick={handleRefresh}
            >
              <Button fullWidth variant="contained" color="primary">
                Open Blog <OpenInBrowser className="ml-2" />
              </Button>
            </a>
          </div>
          <div className="col-6 p-1">
            <a
              href={`https://${blogId}.truvvl.blog/api/edit?editKey=${editKey}`}
              target="_blank"
              rel="nofollow noreferrer noopener"
              onClick={handleRefresh}
            >
              <Button fullWidth variant="outlined" color="primary">
                Open Site Builder <Settings className="ml-2" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    );
  if (error)
    return (
      <div className="mt-3">
        <Typography variant="h4" gutterBottom className="tw-font-bold">
          Something went wrong...
        </Typography>
        <span className="highlightLinks">
          Sorry about that. Please try creating the blog again and{' '}
          <Link href="/about/contact?support=true">contact support</Link> if the
          issue persists.
        </span>
      </div>
    );
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LoadingMorph />
      </Box>
    </Box>
  );
}
